import React from 'react';
import ReactDOM from 'react-dom/client'; // Correct import for React 18
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

// Check if the root element already has content (meaning it was pre-rendered by react-snap)
if (rootElement.hasChildNodes()) {
  // If content exists, hydrate it (attach React to existing HTML)
  ReactDOM.hydrateRoot(rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // If no content exists, create a new root and render the app (standard client-side rendering)
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// This is an optional callback for react-snap to signal when the app's state is ready.
// It's good practice to include, especially if you have asynchronous data loading
// that needs to complete before react-snap takes its snapshot.
window.snapSaveState = () => {
  // You can add logic here to save Redux state, Apollo cache, etc.,
  // if you need to rehydrate complex client-side state after prerendering.
  // For most cases, an empty function is sufficient to signal readiness.
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();